  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  import { getFirestore } from "firebase/firestore";
  import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
  apiKey: "AIzaSyCgJITI0jrmqz1jY9vjU0PnjcJ9Lp8haK8",
  authDomain: "esa2-47b4d.firebaseapp.com",
  projectId: "esa2-47b4d",
  storageBucket: "esa2-47b4d.firebasestorage.app",
  messagingSenderId: "181705197098",
  appId: "1:181705197098:web:354508d67373198a4b2553",
  measurementId: "G-SQE4JHSVZW"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const storage = getStorage(app);
